import {createBrowserRouter} from "react-router";
import Home from "../components/Home";
import PATH from "./routes";
import Layout from "../components/Layout";

const router = createBrowserRouter([
    {
        element: <Layout/>,
        children: [
            {path: PATH.HOME, element: <Home/>},
        ]
    }
])

export default router;